
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/[project]/bonus-content",
      function () {
        return require("private-next-pages/[locale]/watch/[project]/bonus-content/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/[project]/bonus-content"])
      });
    }
  